// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';

// Afidium
import { TemplateListComponent } from './template-list.component';
import { FilterPipeModule } from 'libraries/pipes/filter/filter.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { BackButtonModule } from '../back-button/back-button.module';

@NgModule({
    declarations: [
        TemplateListComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FilterPipeModule,
        MatListModule,
        LoaderModule,
        CardModule,
        BtnModule,
        NotificationModule,
        BackButtonModule,
    ],
    exports: [
        TemplateListComponent,
    ],
    providers: [],
})
export class TemplateListModule {}